module.exports = __webpack_public_path__ + "static/media/calendar_icon.97c6881e.svg";